import { render, staticRenderFns } from "./WycListBtn.vue?vue&type=template&id=788b9fb4&scoped=true&"
import script from "./WycListBtn.vue?vue&type=script&lang=js&"
export * from "./WycListBtn.vue?vue&type=script&lang=js&"
import style0 from "./WycListBtn.vue?vue&type=style&index=0&id=788b9fb4&lang=less&scoped=true&"
import style1 from "./WycListBtn.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b9fb4",
  null
  
)

export default component.exports